import { SETTINGS } from "../lib/constants/actions";

export const getSetting = (data) => { return { type: SETTINGS.GET_SETTING, payload: data }}
export const getSettingSuccess = (data) => { return { type: SETTINGS.GET_SETTING_SUCCESS, payload: data }}

export const saveSetting = (data) => { return { type: SETTINGS.SAVE_SETTING, payload: data }}
export const saveSettingSuccess = (data) => { return { type: SETTINGS.SAVE_SETTING_SUCCESS, payload: data }}



export const saveAppVersion = (data) => { return { type: SETTINGS.SAVE_APP_VERSION_SETTING, payload: data }}
export const saveAppVersionSuccess = (data) => { return { type: SETTINGS.SAVE_APP_VERSION_SETTING_SUCCESS, payload: data }}
export const getAppVersion = (data) => { return { type: SETTINGS.GET_APP_VERSION_SETTING, payload: data }}
export const getAppVersionSuccess = (data) => { return { type: SETTINGS.GET_APP_VERSION_SETTING_SUCCESS, payload: data }}












